export default __webpack_public_path__ + "static/media/10_photo.ed905f3f.jpg";